import script from "./PatientSearchBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./PatientSearchBar.vue?vue&type=script&setup=true&lang=ts"

import "./PatientSearchBar.vue?vue&type=style&index=0&id=590e2a36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-590e2a36"]])

export default __exports__